/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-21 15:54:46
 * @LastEditors: kevinqq 350910378@qq.com
 * @LastEditTime: 2025-03-17 11:17:43
 * @FilePath: \baishu_react_ui\src\components\BsyLinkData\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from "react";

import { BsyWidget } from "../BsyWidget";
import "./index.css";
import BsyIconBtn from "../BsyIconBtn";
import { BsyUtils } from "../../utils/Utils";
import BsyDialog from "../BsyDialog";
import BsySearchInput from "../BsySearchInput";
import BsyMsgBubble from "../BsyMsgBubble";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyMaskLayer from "../BsyMaskLayer";
import BsyFormPane from "../BsyFormPane";
import BsyButton from "../BsyButton";
import BsyFilterPane from "../BsyFilterPane";
import BsyDataTable from "../BsyDataTable";
import { SearchComboPane } from "../BsyDataManage";

export default class BsyLinkData extends BsyWidget {
  constructor(props) {
    super({
      baseCls: "bsy-link-data",
      allowBlank: !0,
      linkFields: [],
      linkKey: null,
      linkFilter: [],
      linkForm: null,
      itemsPerPage: 200,
      layoutSize: {},
      onBeforeLinkData: null,
      refType: null,
      allowAdd: !0, //是否有创建数据的权限
      popupFormPath: [],
      ...props,
    });
    this.value = props.value || null;
    this.state = {
      data: {},
    };
    this.form = props.form;
    this.fieldMap = {};
  }

  getValue = () => {
    if (BsyUtils.isObjectEmpty(this.value)) {
      return null;
    }
    if (BsyUtils.isObjectEmpty(this.value.id)) {
      return null;
    }
    this.value.appId = this.options.refAppId;
    this.value.entryId = this.options.linkForm;
    this.value.linkType = this.options.linkType;
    return this.value;
  };

  checkValidate = () => {

    const b = this.options.allowBlank || !BsyUtils.isObjectEmpty(this.value);
    if (!b) {
      this.setInvalidateTypeText(React.language("item.required"));
    }
    return b;
  };
  extDashData = () => {
    var c = this.options;
    return c.widgetId && !c.rawdata ? c.extDashData : undefined;
  };
  readData = () => {
    let config = {
      designAppId: this.options.designAppId,
      designEntryId: this.options.designEntryId,
      designDataId: this.options.designDataId,
      appId: this.options.appId,
      entryId: this.options.entryId,
      formId: this.options.linkForm,
      linkId: this.value.id,
      refAppId: this.options.refAppId || this.options.appId,
      widgetName: this.options.name || this.options.widgetName,
      subformName: this.options.subform,
      dataId: this.options.dataId,
    };
    React.axios(`/data/read_link`, config).then((res) => {
      BsyUtils.showAjaxTip(
        res.data,
        () => {
          this.setState({ data: res.data.data });
        },
        () => { }
      );
    });
  };

  componentDidMount() {
    super.componentDidMount();

    if (BsyUtils.isObjectEmpty(this.state.data)) {
      if (!BsyUtils.isObjectEmpty(this.value)) {
        this.readData();
      }
    }
  }

  setValue = (t) => {
    if (BsyUtils.isObjectEmpty(t)) this.value = null;
    else {
      this.value = { ...t };
      this.readData();
    }
  };

  loadData = (e) => {
    this.showDataList(e.currentTarget);
  };

  showDataList = () => {
    let that = this;
    if (!this.isEnabled()) return;

    const { linkForm } = this.options;
    if (BsyUtils.isObjectEmpty(linkForm)) {
      return;
    }
    let fieldHasKey = false;
    let tlinkFields = that.options.linkFields.map((linkField) => {
      if (linkField.type === "subform") {
        return {
          ...linkField,
          subform_create: false,
          subform_insert: false,
          subform_edit: false,
          subform_sort: false,
          subform_delete: false,
          subform_import: false,
          subform_dataload: false,
          items: linkField.items.map((i) => {
            return Object.assign({}, i.widget, {
              name: i.widget.widgetName,
              text: i.label,
              type: i.widget.type,
            });
          }),
        };
      } else {
        linkField.name === that.options.linkKey && (fieldHasKey = true);
        return linkField;
      }
    });
    if (BsyUtils.isObjectEmpty(tlinkFields)) {
      tlinkFields = [
        {
          name: "label",
          text: "标题",
          type: "textarea",
        },
      ];
    }
    if (that.options.linkKey && !fieldHasKey) {
      tlinkFields.push({
        name: that.options.linkKey,
        text: React.language("field.key"),
        type: that.options.linkType,
        detailOnly: true,
      });
    }

    BsyDialog({
      title: React.language("widget.linkdata.select"),
      height: 600,
      width: 800,
      hasFullScreen: true,
      noFooter: true,
      onContentCreate: (ref) => {
        return (
          <ShowDataListPane
            formMode={that.getFormMode()}
            data={that.props.data}
            onSelect={(e) => {
              if (that.value && that.value.id === e._id) {
                that.setState(
                  {
                    data: {},
                  },
                  () => {
                    that.value = null;
                    BsyUtils.applyFunc(
                      that,
                      that.props.onStopEdit,
                      [that.value, null, that],
                      !1
                    );
                  }
                );
              } else {
                that.setState(
                  {
                    data: e,
                  },
                  () => {
                    if (e) {
                      that.value = {
                        appId: that.options.refAppId,
                        entryId: that.options.linkForm,
                        id: e._id,
                        linkType: that.options.linkType,
                        key: that.props.linkKey ? e[that.props.linkKey] : "",
                      };
                    } else {
                      that.value = null;
                    }
                    BsyUtils.applyFunc(
                      that,
                      that.props.onStopEdit,
                      [that.value, null, that],
                      !1
                    );
                  }
                );
              }

              ref.closeAlter();
            }}
            {...that.options}
            linkFields={tlinkFields}
            baseCls="bsy-show-data-list-pane"
            getContext={null}
            value={this.value}
          />
        );
      },
    });
  };

  renderField = (item) => {
    const { data } = this.state;
    let value = data ? data[item.name] : "";
    const { refAppId, linkForm, appId, dataId, formId } = this.options;
    let config = { ...item };
    config.value = value;
    config.appId = appId;
    config.dataId = dataId;
    config.formId = formId;
    if (config.type === "subform") {
      config.isformdata = true;
      config.rootElement = this.form ? this.form.element.current : null;
      config.enable = false;
      config.subform_create = false;
      config.subform_insert = false;
      config.subform_edit = false;
      config.subform_sort = false;
      config.subform_delete = false;
      config.subform_import = false;
      config.subform_dataload = false;
      for (let i = 0; i < config.items.length; i++) {
        config.items[i].enable = false;
      }
    } else {
      config.enable = false;
    }
    config.refAppId = refAppId;
    config.linkForm = linkForm;
    return (
      <div className="link-field">
        <div className="fl-label">{item.text}</div>
        {BsyUtils.createWidget(config)}
        {/* <div className="bsy_form_item_disable" data-watermark={React.language('content.empty')} title={value} >{value}</div> */}
      </div>
    );
  };

  render() {
    const { css, cssName, linkFields } = this.options;
    return (
      <div className={cssName} ref={this.element}>
        {this.isEnabled() ? (
          <BsyIconBtn
            style={css}
            text={React.language("click.select.data")}
            type="white"
            width={"100%"}
            iconName="icon-bsy-iconguanlianshuju"
            click={this.loadData}
            mode={window.mode}
          ></BsyIconBtn>
        ) : (
          ""
        )}

        <div className="field-list" key={BsyUtils.Ids24()}>
          {linkFields.map((e) => {
            return this.renderField(e);
          })}
        </div>
      </div>
    );
  }
}

export class ShowDataListPane extends BsyWidget {
  constructor(props) {
    super({
      minWidth: 100,
      baseCls: "bsy-show-data-list-pane",
      ...props,
    });

    this.state = {
      datalist: [],
      seachKey: "",
      allowAdd: props.allowAdd,
      loading: false,
    };

    this.filter = [];
    this.search = {
      fields: [],
      isSearchAllFields: true,
      keywords: [],
    };
  }

  componentDidMount() {
    super.componentDidMount();
  }

  getFilterConfig = () => {
    const {
      appId,
      refAppId,
      linkForm,
      designEntryId,
      designAppId,
      subform,
      widgetName,
    } = this.options;

    let that = this;
    let fields = [];
    this.options.linkFields.map((event) => {
      fields.push({
        ...event,
        appId: refAppId ? refAppId : appId,
        designEntryId: designEntryId,
        designAppId: designAppId,
        designSubform: subform,
        designWidgetName: widgetName,
        entryId: linkForm,
        formId: linkForm,
        id: linkForm,
      });
    });

    return {
      hasRelation: false,
      hasPin: true,
      // hasHeader: filterSticky ? true : false,
      hasHeader: true,
      filterSticky: false,
      filterTopSticky: false,
      hasfilterSticky: false,
      hasfilterTopSticky: false,
      rel: this.rel || "and",
      cond: this.filter || [],
      onBeforeAsync: () => {
        const linkFilters = BsyUtils.applyFunc(
          this,
          this.options.onBeforeLinkData,
          [that.options.linkFilter, null, this],
          !1
        );
        if (linkFilters?.all) {
          return undefined;
        }
        return linkFilters;
      },
      entryList: {
        [this.options.entryId]: {
          id: this.options.entryId,
          name: this.options.formName,
          fields: fields,
        },
      },
      onFilterClose: () => {
        this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
      },
      onFilterSticky: () => {
        const { filterSticky } = this.state;
        if (!filterSticky) {
          this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        }
      },
      onFilterTopSticky: () => {
        const { filterTopSticky } = this.state;
        if (!filterTopSticky) {
          this.filterPaneContext && this.filterPaneContext.onRemoveRoot();
        }
      },
      onSetFieldFilter: (val) => {
        this.rel = val.rel;
        this.filter = [...val.cond];
      },
      onFilter: (val, clearFilter) => {
        this.rel = val.rel;

        if (clearFilter) {
          this.filter = [];
        } else {
          this.filter = [...val.cond];
        }
        this.componentContext.reload();
        // this.setFilterCache(val)
      },
    };
  };

  addData = () => {
    const { ignoreOptAuth, appId, refAppId, linkForm } = this.options;
    let that = this;
    if (window.FX.STATIC.FTOKEN) {
      tipAlert({
        type: "warning",
        msg: React.language("no.operation.authority"),
      });
      return;
    }

    if (this.getFormMode() === "preview") {
      tipAlert({
        type: "warning",
        msg: React.language("preview.create.data"),
      });
      return;
    }

    if (ignoreOptAuth) {
      tipAlert({
        type: "warning",
        msg: React.language("data.manager.create.data"),
      });
      return;
    }

    React.axios(
      "/dashboard/app/" +
      (refAppId ? (refAppId === appId ? appId : refAppId) : appId) +
      "/entry/" +
      linkForm
    ).then((res) => {
      BsyUtils.showAjaxTip(
        res.data,
        () => {
          that.creatForm(res);
        },
        () => { }
      );
    });
  };

  creatForm = (res) => {
    let that = this;
    let {
      popupFormPath = [],
      subform,
      widgetName,
      designAppId,
      designEntryId,
    } = this.options;

    const h = res ? res.data.entry : {};

    window.FX.STATIC.appId = h.appId;
    window.FX.STATIC.entryId = h.entryId;
    window.FX.STATIC.INNERLINK = h._id;

    if (!BsyUtils.isObjectEmpty(h.href)) {
      window.FX.STATIC.FORMHREF = h.href;
    } else {
      window.FX.STATIC.FORMHREF = null;
    }

    let formConfig = {
      ...h,
      appId: h.appId,
      entryId: h.entryId,
    };
    formConfig.content.width = "80%";
    formConfig.content.name = h.name;
    formConfig.content.islinkdata = true;
    formConfig.content.designWidgetName = widgetName;
    formConfig.content.designSubformName = subform;

    let layerRef = null;
    BsyMaskLayer({
      customCls: "fadein-right",
      onMaskClick: (event) => {
        // if (event.target.classList.contains("BsyMaskLayer")) {
        //   layerRef.close();
        // }
      },
      onContentCreate: (ref) => {
        layerRef = ref;
        return (
          <BsyFormPane
            hasHeader={true}
            popupFormPath={popupFormPath.concat({
              appId: designAppId,
              entryId: designEntryId,
              formId: formConfig.formId || formConfig.entryId,
              subform: subform,
              widgetName: widgetName,
              islinkdata: true,
            })}
            formConfig={formConfig}
            mode={"new"}
            onClose={(status) => {
              if (status) {
                that.componentContext.reload({});
              }
              layerRef && layerRef.close();
            }}
          />
        );
      },
    });
  };

  loadData = (config, cb) => {
    this.dataMap = {};
    let that = this;
    // let fields = this.options.linkFields.map(e => {
    //     return { type: e.type, name: e.name };
    // });

    let filter = BsyUtils.applyFunc(
      that,
      that.options.onBeforeLinkData,
      [that.options.linkFilter, null, this],
      !1
    );

    if (BsyUtils.isObjectEmpty(filter)) {
      cb &&
        cb({
          data: {
            count: 0,
            header: that.options.linkFields,
            data: [],
          },
        });
      return;
    }

    let data = {
      designAppId: this.options.designAppId,
      designEntryId: this.options.designEntryId,
      appId: this.options.appId,
      entryId: this.options.entryId,
      formId: this.options.linkForm,
      fields: this.options.linkFields,
      queryFilter: !BsyUtils.isObjectEmpty(this.filter)
        ? {
          cond: this.filter,
          rel: "and",
        }
        : undefined,
      filter: filter,
      isNewFilter: true,
      search: this.search,
      // limit: 500,
      // skip: this.page * 500,
      multi: true,
      refAppId: this.options.refAppId,
      widgetName: this.options.name || this.options.widgetName,
      subformName: this.options.subform,
      ...config,
    };
    // this.setState({ loading: true });
    React.axios(`/data/filter`, data).then((res) => {
      BsyUtils.showAjaxTip(res.data, () => {
        that.options.formName = res.data.formName;
        that.count = res.data.count;
        cb &&
          cb({
            data: {
              highlightFields: res.data.highlightFields,
              count: res.data.count,
              header: that.options.linkFields,
              data: res.data.result,
            },
          });
      });
    });
  };

  onGetFilterPaneContext = (context) => {
    this.filterPaneContext = context;
  };

  tableHeader = () => {
    const { allowAdd, ignoreOptAuth } = this.options;
    let that = this;
    return (
      <div className="data-header">
        <div className="left-pane">
          {ignoreOptAuth || allowAdd ? (
            <BsyButton
              text={React.language("create")}
              iconName={"icon-bsy-add"}
              height={30}
              click={() => {
                this.addData();
              }}
              mode={window.mode + " add "}
            />
          ) : (
            ""
          )}
        </div>
        <div className="right-pane">
          <BsyButton
            height={30}
            onMouseEnter={(event) => {
              window.FX.UI.showPopover({
                position: "leftBottom",
                anchor: window.$(event.target),
                content: window
                  .$("<span/>")
                  .text(React.language("filter.condition")),
                type: "dark",
              });
            }}
            onMouseLeave={() => {
              window.FX.UI.closePopover();
            }}
            tip={React.language("filter.condition")}
            type={"menu-right"}
            iconName={"icon-bsy-shaixuananniu"}
            click={(e) => {
              let config = that.getFilterConfig();
              BsyMsgBubble({
                anchor: e.currentTarget,
                customCls: "filter-bubble",
                onGetContext: that.onGetFilterPaneContext,
                contentHTML: () => {
                  return <BsyFilterPane {...config}></BsyFilterPane>;
                },
                text4Cancel: null,
                text4Ok: null,
                theme: this.props.theme,
                minWidth: "auto",
                width: 350,
                contentPadding: 0,
                edge: 200,
                hAdjust: 72,
                dockPosition: "right",
                onClose: function () {
                  that.setState({});
                  return !1;
                },
              });
            }}
            mode={window.mode}
          />

          {
            <BsySearchInput
              placeholder={React.language("search.data")}
              styleInput={{
                width: "200px",
              }}
              onSearch={(val) => {
                if (val) {
                  this.search.keywords = [val];
                } else {
                  this.search.keywords = [];
                }
                this.onSearchText();
              }}
              type={window.mode}
              // iconName="icon-bsy-reportmenu-0"
              onExtElement={() => {
                return (
                  <>
                    <i onClick={this.onSearchFields} className="icon-bsy-xia" />
                  </>
                );
              }}
            ></BsySearchInput>
          }
        </div>
      </div>
    );
  };

  getSearchCacheKey = () => {
    const { entryId, appId, widgetName } = this.options;
    // const { appId, entryId, authGroupId } = this.state;
    return BsyUtils.Store.getKey("searchValue", {
      appId: appId,
      entryId: entryId,
      ext: widgetName,
      authGroupId: "showdata",
    });
  };

  setSearchCach = (val) => {
    BsyUtils.Store.set(this.getSearchCacheKey(), val);
  };

  getSearchCach = () => {
    let res = BsyUtils.Store.get(this.getSearchCacheKey());
    if (res) {
      this.search = res;
    }
    this.setSearchCach(null);
  };

  onSearchFields = (event) => {
    this.showCombo(event.currentTarget);
  };

  showCombo = (currentTarget) => {
    const { linkFields } = this.options;
    this.fields = linkFields.filter((event) => {
      if (!event.detailOnly) {
        return true;
      }

      return event.name !== "label";
    });
    let that = this;
    // this.getSearchCach();
    BsyMsgBubble({
      anchor: currentTarget,
      contentHTML: () => {
        return (
          <SearchComboPane
            getContext={(e) => {
              that.searchContext = e;
            }}
            allCount={this.componentContext.state.allCount}
            formItems={this.fields}
            value={this.search}
          />
        );
      },
      text4Cancel: null,
      text4Ok: null,
      theme: this.props.theme,
      minWidth: "auto",
      width: 210,
      contentPadding: 0,
      edge: 200,
      hAdjust: 72,
      dockPosition: "left",
      onClose: function () {
        that.searchFields = that.searchContext.fields;
        that.search = that.searchContext.getValue();
        if (that.search.keywords.length) {
          that.onSearchText();
        }
        that.setSearchCach(that.search);
        return !1;
      },
    });
  };

  getFieldConfig = () => {
    const { linkFields, entryId, appId, linkForm, value } = this.options;

    let config = {
      url: "/data/filter",
      entryId: entryId,
      fields: linkFields,
      appId: appId,
      formId: linkForm,
      forms: [linkForm],
      checkStatus: "radio",
      width: "100%",
      height: "100%",
      widgetId: this.props.widgetId || "linkdatadatatable",
      jsplatform: "React",
      autoHeight: "low",
      selectDataId: value?.id ? [value?.id] : [],
      onDataGet: (url, config, cb) => {
        this.loadData(
          {
            limit: config.limit,
            skip: config.skip,
          },
          cb
        );
      },
    };
    return config;
  };

  getContext = (context) => {
    this.componentContext = context;
  };

  tableBody = () => {
    let config = this.getFieldConfig();

    return (
      <div className="data-body">
        <BsyDataTable
          {...config}
          skip={this.skip || 0}
          hasCount={false}
          getContext={this.getContext}
          level2Menu={true}
          key={this.componentKey}
          isCheckAll={false}
          onDataFilter={this.onDataFilter}
          is_dock_form={false}
          selectSingleData={(data) => {
            this.props.onSelect && this.props.onSelect(data);
          }}
        />
      </div>
    );
  };

  onSearchText = () => {
    let that = this;
    if (this.search.keywords && this.search.keywords.length) {
      if (this.componentContext.state.allCount > 10000) {
        if (this.search.isSearchAllFields == true) {
          this.search.isSearchAllFields = false;

          let n = 5;
          if (this.search.fields.indexOf("label") > -1) {
            n = 6;
          }

          if (this.search.fields.length === 0) {
            n = 6;
          }

          BsyUtils.forEach(this.fields, (a1, b1) => {
            if (that.search.fields.length >= n) {
              return false;
            }
            if (that.search.fields.indexOf(b1.name) === -1) {
              that.search.fields.push(b1.name);
            }
          });
        }
      }

      this.componentContext.reload({
        search: this.search,
        skip: 0,
      });
    } else {
      this.componentContext.reload({ search: null, skip: 0 });
    }
  };

  render() {
    const { cssName } = this.options;
    const { datalist, allowAdd, loading } = this.state;

    return (
      <div className={cssName}>
        {this.tableHeader()}
        {this.tableBody()}
      </div>
    );
  }
}
